const button = "_j0jbx8tnai";
const icon = "_j0ji1is3ce6";

export { button, icon };
import "./favourite-button.style.linaria.module.css";
//# sourceMappingURL=favourite-button.style.js.map
